import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { login } from 'apa/actions';
import { Redirect } from 'react-router-dom';
import autobind from 'autobind-decorator';
import {
    Alert,
    Button,
    Container,
    Modal,
    ModalHeader,
    ModalBody,} from 'reactstrap'
import Loading from 'apa/components/Loading';
import {CodeDetails} from 'apa/containers/TrainingOverview';
import {NavLink} from 'react-router-dom'


@connect(
    state => ({
        isLoading: state.apa.isLoading,
        user: state.apa.user
    }),
    dispatch => ({
        login: (username, password) => (dispatch(login(username, password)))
    })
)
export default class Home extends Component {

    constructor(props) {
        super(props);
    }

    state = { isResultDetailsModalOpen: false }

    render() {
        const isLoading = this.props.isLoading;
        if(isLoading) {
            return <Loading/>
        }
        const user = this.props.user;
        const attempts = user.access_code.attempts
        const status = user.access_code.status;
        const results = user.access_code.results;

        const { max, correct, percentage } = results

        const toggleResultDetailsModal = () => {
            this.setState({
                isResultDetailsModalOpen: !this.state.isResultDetailsModalOpen,
            });
        };

        if(status === 0) {
            return <Redirect to={'/training/test/'}/>
        }
        let color, msg, msg1, msg2;
        let Percentage = Math.round(percentage)
        if(status==1 && attempts > 0) {
            color = 'danger'
            msg = 'Achtung!'
            msg1 = <>Schade, die von Ihnen erreichte Punktzahl reicht leider nicht aus.</>
            msg2 = <>Versuchen Sie es noch einmal. Insgesamt haben Sie drei Versuche.</>
        } else if(status==2 && attempts > 0 ) {
            color = 'warning'
            msg = 'Achtung!'
            msg1 = <>Schade, da fehlen nur ein paar Punkte. Das Ziel wurde knapp verfehlt.</>
            msg2 = <>Schauen Sie sich die Präsentation noch einmal an oder starten Sie direkt einen neuen Versuch mit einer kleinen Wissenskontrolle, um die notwendige Punktzahl zu erreichen.</>
        }else if((status==1 || status==2) && attempts == 0) {
            color = 'warning'
            msg = 'Achtung!'
            msg1 = <>Upps, die notwendige Punktanzahl wurde nicht erreicht.</>
            msg2 = <>Wie schade, es fehlen immer noch ein paar Punkte. Vielen Dank für Ihre Teilnahme.</>
        }
        else {
            color = 'success'
            msg = 'Glückwunsch!'
            msg1 = <>Großartig! Sie haben die notwendige Punktzahl erreicht.</>
            msg2 = <></>
        }
        return (
            <Container style={{'margin': '3em auto', 'width': '40em'}}>
                <Alert color={color}>
                    <h1>
                        {msg}
                    </h1>
                    <p>
                        {msg1}
                    </p>

                </Alert>
                    <p>
                        <strong>Punktzahl: {correct} / {max} ({Percentage} %)</strong>
                    </p>
                {attempts > 0 ? <p><strong>Anzahl weiterer Versuche:</strong> {attempts}</p> : <p></p>}
                    <p>
                        {msg2}
                    </p>
                    <p>
                    <Button
                        color="primary"
                        onClick={toggleResultDetailsModal}>
                        Detaillierte Auswertung öffnen
                    </Button>
                    </p>


                    <Modal isOpen={this.state.isResultDetailsModalOpen} toggle={toggleResultDetailsModal} size="lg">
                        <ModalHeader toggle={toggleResultDetailsModal}>Auswertung des letzten Versuchs</ModalHeader>
                        <ModalBody>
                            <CodeDetails codeDetails={user.access_code} hideID={true} />
                        </ModalBody>
                    </Modal>
                    {
                    status==1 && attempts > 0 ?
                        (
                            <div>
                                <p>
                                    <a className="btn btn-primary" href='/training/test'>{`Wissenskontrolle erneut starten`}</a>
                                </p>
                            </div>
                        ): status==2 && attempts > 0 ? (
                            <div>
                                <p>
                                    <a className="btn btn-primary" href='/training/test'>{`Kleine Wissenskontrolle starten`}</a>
                                </p>
                            </div>
                        ): (
                            null
                        )
                    }

                {
                    status == 3 ?
                        (
                            <p> Herzlichen Glückwunsch, hier können Sie die Bestätigung Ihrer erfolgreichen Teilnahme ausdrucken.<br/>
                                <a className="btn btn-primary" href={user.access_code.certificate} target="_blank">Teilnahmeurkunde</a>
                            </p>

                        ) : (status == 1 || status == 2) && attempts > 0 ?
                        (
                        null
                        ): (
                        <p> Hier können Sie Ihre Teilnahmebestätigung ausdrucken.<br/>
                            <a className="btn btn-primary" href={user.access_code.certificate} target="_blank">Teilnahmebestätigung</a>
                        </p>
                        )
                }



                    {
                        (status == 1 || status == 2) && attempts > 0 ? (<p>
                            <a className="btn btn-primary" href={'/training/do'}>Zurück zur Präsentation</a>
                        </p>):null
                }
                <div><br/><br/>
                <p>Sie haben Fragen zum Arbeits- Brand- Gesundheitsschutz oder zur Präsentation, dann schicken Sie uns bitte unter: <a href="mailto:info@sicher-arbeiten.Hamburg">info@sicher-arbeiten.Hamburg</a> eine E-Mail.</p>
                <p>Ihre E-Mails werden absolut vertraulich behandelt. Es sei denn, Sie wünschen ausdrücklich die Weitergabe Ihre Mail / des Inhalts an die Verantwortlichen Ihres Unternehmens – ist auch ohne Ihre Personalisierung möglich</p>
                    <p>Wir wünschen Ihnen ein Unfallfreies Jahr. Bleiben Sie gesund!<br />Ihre Fachkraft für Arbeitssicherheit und Brandschutz</p>
                    <p><br /></p>
                </div>

            </Container>
        )
    }
}

Home.propTypes = {
    login: PropTypes.func,
    isAuthenticated: PropTypes.bool,
    errors: PropTypes.object
}
